module.exports = __webpack_public_path__ + "img/line-transactional.4584a6ac.svg";